export const LOCAL_STORAGE_KEY = {
  country: {
    code: 'countryCode',
    services: 'countryServices',
    currency: {
      prefix: 'countryCurrencyPrefix',
    },
  },
} as const;
